import { render, staticRenderFns } from "./settings-organization-spam-dialog.vue?vue&type=template&id=98938ff4&scoped=true&"
import script from "./settings-organization-spam-dialog.vue?vue&type=script&lang=js&"
export * from "./settings-organization-spam-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98938ff4",
  null
  
)

export default component.exports